
import { Dialog } from "element-ui"
import { priceFormatOther } from "@/utils/utils"

export default {
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderList: {
      type: Array,
      default: () => []
    },
    currentStamp: {
      type: Object,
      default: () => ({
        name: "",
        list: []
      })
    }
  },
  data() {
    return {
      curVisible: this.visible
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
    }
  },
  methods: {
    priceFormatOther,
    handleClose() {
      this.$emit("close")
    }
  }
}
